module.exports = "//public.zight.com/packs/media/images/annotate/emoji@2x-acbf90dbc046c92e1efa9d82b7450659.png";